<app-dialog-template>
  <app-dialog-template-header>
    <app-dialog-template-title>
      <ng-container>
        {{ 'FORMATTING.CONDITIONAL_TITLE' | translate }}
      </ng-container>
    </app-dialog-template-title>
  </app-dialog-template-header>

  <app-dialog-template-body>
    <form [formGroup]="form">
      <div class="c-formatting-dialog">
        <ng-container [formArrayName]="'formats'">
          <ng-container *ngFor="let formatFormGroup of formatsGroups; index as i, last as last">
            <ng-container [formGroup]="formatFormGroup">
              <div class="c-formatting-dialog__items-wrapper">
                <div class="c-formatting-field-item">
                  <app-select
                    [isFullWide]="true"
                    [formControlName]="'fieldName'"
                    [label]="'FILTERS.FIELD' | translate"
                    [options]="getSelectOptions(i)"
                    (selectionChanged)="updateProperties($event, formatFormGroup)"
                  >
                  </app-select>
                </div>
                <div class="c-formatting-field-item">
                  <app-select
                    [isFullWide]="true"
                    [formControlName]="'operation'"
                    [label]="'FILTERS.OPERATORS.TITLE' | translate"
                    [options]="formatFormGroup.controls.fieldType.value | setDevExtremeOperators"
                    (selectionChanged)="enableValueFormControl(i)"
                  >
                  </app-select>
                </div>
                <div class="c-formatting-field-item">
                  <ng-container
                    *ngIf="formatFormGroup.controls.fieldType?.value === DevExtremeFieldTypesEnum.STRING || formatFormGroup.controls.fieldType?.value === DevExtremeFieldTypesEnum.NUMBER || !formatFormGroup.controls['fieldName'].value">
                    <app-input-text
                      [formControlName]="'value'"
                      [label]="'FILTERS.VALUE' | translate"
                      [isFullWide]="true">
                    </app-input-text>
                  </ng-container>
                  <ng-container
                    *ngIf="formatFormGroup.controls.fieldType?.value === DevExtremeFieldTypesEnum.DECIMAL_NUMBER">
                    <app-input-number
                      [formControlName]="'value'"
                      [numberOfDecimals]="2"
                      [inputAlignment]="'right'"
                      [label]="'FILTERS.VALUE' | translate"
                      [isFullWide]="true">
                    </app-input-number>
                  </ng-container>
                  <ng-container *ngIf="formatFormGroup.controls.fieldType?.value === DevExtremeFieldTypesEnum.SELECT">
                    <app-select
                      [isFullWide]="true"
                      [formControlName]="'value'"
                      [label]="'FILTERS.VALUE' | translate"
                      [options]="formatFormGroup.controls.fieldName?.value | setSelectOptions: data.fields">
                    </app-select>
                  </ng-container>
                  <ng-container
                    *ngIf="formatFormGroup.controls.fieldType?.value === DevExtremeFieldTypesEnum.BOOLEAN">
                    <app-bui-slide-toggle
                      [labelPosition]="'after'"
                      [label]="'FILTERS.VALUE' | translate"
                      [formControlName]="'value'">
                    </app-bui-slide-toggle>
                  </ng-container>
                  <ng-container
                    *ngIf="formatFormGroup.controls.fieldType.value === DevExtremeFieldTypesEnum.DATE_TIME">
                    <app-bui-datetime-picker
                      [label]="'FILTERS.VALUE' | translate"
                      [placeholder]="'COMMON.ENTER_DATE_TIME' | translate"
                      [formControlName]="'value'"
                      [isFullWide]="true">
                    </app-bui-datetime-picker>
                  </ng-container>
                  <ng-container *ngIf="formatFormGroup.controls.fieldType.value === DevExtremeFieldTypesEnum.DATE">
                    <app-bui-date-picker
                      [label]="'FILTERS.VALUE' | translate"
                      [placeholder]="'COMMON.ENTER_DATE' | translate"
                      [formControlName]="'value'"
                      [isFullWide]="true">
                    </app-bui-date-picker>
                  </ng-container>
                </div>
                <div class="c-formatting-field-item">
                  <mat-form-field [appearance]="'outline'" [floatLabel]="'always'" class="u-mat-full">
                    <mat-label [matTooltip]="'FORMATTING.TEXT_COLOR' | translate">{{ 'FORMATTING.TEXT_COLOR' | translate }}</mat-label>
                    <input matInput [ngxMatColorPicker]="picker" [formControlName]="'textColor'">
                    <ngx-mat-color-toggle matSuffix [for]="picker"></ngx-mat-color-toggle>
                    <ngx-mat-color-picker #picker></ngx-mat-color-picker>
                  </mat-form-field>
                </div>
                <div class="c-formatting-field-item">
                  <mat-form-field [appearance]="'outline'" [floatLabel]="'always'" class="u-mat-full">
                    <mat-label [matTooltip]="'FORMATTING.TEXT_HIGHLIGHT' | translate">{{ 'FORMATTING.TEXT_HIGHLIGHT' | translate }}</mat-label>
                    <input matInput [ngxMatColorPicker]="picker_highlight" [formControlName]="'textHighlightColor'">
                    <ngx-mat-color-toggle matSuffix [for]="picker_highlight"></ngx-mat-color-toggle>
                    <ngx-mat-color-picker #picker_highlight></ngx-mat-color-picker>
                  </mat-form-field>
                </div>
                <div class="c-formatting-field-item">
                  <app-select
                    [isFullWide]="true"
                    [formControlName]="'textStyle'"
                    [label]="'FORMATTING.TEXT_STYLE' | translate"
                    [options]="textStyle">
                  </app-select>
                </div>
                <div class="c-formatting-field-item">
                  <div class="u-form-element__label">
                    {{ 'FORMATTING.TEXT_PREVIEW' | translate }}
                  </div>
                  <div class="c-formatting-dialog-preview">
                    <div *ngIf="!formatFormGroup.controls.value.value"
                         [ngStyle]="{'color': formatFormGroup.controls.textColor.value, 'backgroundColor': formatFormGroup.controls.textHighlightColor.value, 'textDecoration': formatFormGroup.controls.textStyle.value, 'fontWeight': formatFormGroup.controls.textStyle.value, 'fontStyle': formatFormGroup.controls.textStyle.value}"
                         class="c-formatting-dialog__cell-style-preview">{{formatFormGroup.controls.fieldName.value}}</div>
                    <div *ngIf="formatFormGroup.controls.value.value">
                      <div [ngSwitch]="formatFormGroup.controls.fieldType.value">
                        <div
                          *ngSwitchCase="DevExtremeFieldTypesEnum.DATE_TIME"
                          [ngStyle]="{'color': formatFormGroup.controls.textColor.value, 'backgroundColor': formatFormGroup.controls.textHighlightColor.value, 'textDecoration': formatFormGroup.controls.textStyle.value, 'fontWeight': formatFormGroup.controls.textStyle.value, 'fontStyle': formatFormGroup.controls.textStyle.value}"
                          class="c-formatting-dialog__cell-style-preview">{{formatFormGroup.controls.value.value | setDateTime}}
                        </div>
                        <div
                          *ngSwitchCase="DevExtremeFieldTypesEnum.DATE"
                          [ngStyle]="{'color': formatFormGroup.controls.textColor.value, 'backgroundColor': formatFormGroup.controls.textHighlightColor.value, 'textDecoration': formatFormGroup.controls.textStyle.value, 'fontWeight': formatFormGroup.controls.textStyle.value, 'fontStyle': formatFormGroup.controls.textStyle.value}"
                          class="c-formatting-dialog__cell-style-preview">{{formatFormGroup.controls.value.value | formatDate}}
                        </div>
                        <div
                          *ngSwitchCase="DevExtremeFieldTypesEnum.STRING"
                          [ngStyle]="{'color': formatFormGroup.controls.textColor.value, 'backgroundColor': formatFormGroup.controls.textHighlightColor.value, 'textDecoration': formatFormGroup.controls.textStyle.value, 'fontWeight': formatFormGroup.controls.textStyle.value, 'fontStyle': formatFormGroup.controls.textStyle.value}"
                          class="c-formatting-dialog__cell-style-preview">{{formatFormGroup.controls.value.value}}
                        </div>
                        <div
                          *ngSwitchCase="DevExtremeFieldTypesEnum.BOOLEAN"
                          [ngStyle]="{'color': formatFormGroup.controls.textColor.value, 'backgroundColor': formatFormGroup.controls.textHighlightColor.value, 'textDecoration': formatFormGroup.controls.textStyle.value, 'fontWeight': formatFormGroup.controls.textStyle.value, 'fontStyle': formatFormGroup.controls.textStyle.value}"
                          class="c-formatting-dialog__cell-style-preview">{{formatFormGroup.controls.value.value}}
                        </div>
                        <div
                          *ngSwitchCase="DevExtremeFieldTypesEnum.NUMBER"
                          [ngStyle]="{'color': formatFormGroup.controls.textColor.value, 'backgroundColor': formatFormGroup.controls.textHighlightColor.value, 'textDecoration': formatFormGroup.controls.textStyle.value, 'fontWeight': formatFormGroup.controls.textStyle.value, 'fontStyle': formatFormGroup.controls.textStyle.value}"
                          class="c-formatting-dialog__cell-style-preview">{{formatFormGroup.controls.value.value}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="c-formatting-dialog__actions">
                  <div class="c-formatting-action-item">
                    <app-bui-slide-toggle
                      [formControlName]="'isRowColoring'"
                      [tooltip]="'FORMATTING.ROW_COLORING' | translate">
                    </app-bui-slide-toggle>
                  </div>
                  <div class="c-formatting-action-item">
                    <app-bui-button-icon
                      [disabled]="formatsGroups.length <= 1"
                      [iconName]="'delete'"
                      [comboStyle]="'settings'"
                      [borderStyle]="'dark'"
                      (clickEvent)="deleteFormat(i)">
                    </app-bui-button-icon>
                  </div>
                  <div class="c-formatting-action-item">
                    <ng-container *ngIf="last">
                      <app-bui-button-icon
                        [disabled]="!form.valid"
                        [iconName]="'plus'"
                        [comboStyle]="'settings'"
                        [borderStyle]="'dark'"
                        (clickEvent)="addFormatFormGroup()">
                      </app-bui-button-icon>
                    </ng-container>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
      <div class="c-formatting-dialog__label-clear-filter">
        <app-bui-button-label
          [comboStyle]="'naked-link'"
          (clickEvent)="clearFilters()">
          {{'COMMON.CLEAR_ALL' | translate}}
        </app-bui-button-label>
      </div>
    </form>
  </app-dialog-template-body>
  <app-dialog-template-footer>
    <app-bui-button-label
      [comboStyle]="'outline'"
      (clickEvent)="closeDialog()">
      {{'POPUP_FILTER_LIST_DIALOG.CANCEL' | translate}}
    </app-bui-button-label>
    <app-bui-button-label
      [comboStyle]="DialogTemplateButtonComboStyleEnum.FILL_GRADIENT_1"
      (clickEvent)="applyNewFormat()">
      {{'POPUP_FILTER_LIST_DIALOG.SAVE' | translate}}
    </app-bui-button-label>
  </app-dialog-template-footer>
</app-dialog-template>
